import { defineStore } from 'pinia';

import * as state from './user.state';
import * as getters from './user.getters';
import * as actions from './user.actions';

export const useUserStore = defineStore('user', () => ({
  ...state,
  ...getters,
  ...actions
}));
